export const SESSION_EXPIRED_DEDUPE_KEY = 'session-expired-global';
export const SESSION_EXPIRED_DEDUPE_TTL = 5 * 60 * 1000; // 5 minutes

